// @ts-nocheck

import React, { useState, useEffect } from "react";
import SoftBox from "../../../components/common/softBox";
import SoftTypography from "../../../components/common/softTypography";
import SoftInput from "../../../components/common/softInput";
import SoftButton from "../../../components/common/softButton";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { createRoom } from "../../../features/room";
import { getRoomTypes } from "../../../features/roomType";


const AddRoom = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate()

  const [formData, setFormData] = useState({
    room_number: "",
    room_type: "", 
    status: "Available",
    price: "",
    
   
    additional_details: "",
  });

  const { roomTypes, status } = useSelector(state => state.roomType); // Assuming room types are fetched here

  useEffect(() => {
console.log('roomType..');

      dispatch(getRoomTypes());
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = () => {
    console.log(formData, "formData");
    // Dispatch createRoom with formData
       

    dispatch(createRoom(formData))
       

      .then((res) => {
       

        const notify = () => toast.success(res.payload.message); // Assuming you have a toast function
        notify();
        navigate('/room'); 
        console.log(res, "response");
      })
       

      .catch((err) => {
        console.log(err, "error");
      });
  };

  console.log(roomTypes,'roomTypes');
  

  return (
       

    <SoftBox
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh"
      bgColor="white"
      shadow="lg"
      borderRadius="lg"
      p={4}
      mt={15}
    >
          

      <SoftBox width="100%" maxWidth="400px">
                


        <SoftBox mb={2}>
          

          <SoftTypography variant="h4" fontWeight="bold" textAlign="center">
            Add Room
          </SoftTypography>
        </SoftBox>
          

        <SoftBox component="form" role="form">
          {/* Room Number Input */}
          

          <SoftBox mb={2}>
          

            <SoftBox mb={1} ml={0.5}>
          

              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Room Number
              </SoftTypography>
            </SoftBox>
            <SoftInput
       

              type="number"
              name="room_number"
              placeholder="Enter the room number"
              value={formData.room_number}
              onChange={handleChange}
            />
          </SoftBox>

          {/* Room Type Dropdown */}
          

          <SoftBox mb={2}>
          

            <SoftBox mb={1} ml={0.5}>
          

              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Room Type
              </SoftTypography>
            </SoftBox>
            <select
              name="room_type"
              value={formData.room_type}
              onChange={handleChange}
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "5px",
                border: "1px solid #ccc",
              }}
            >
              <option value="">Select Room Type</option>
              {roomTypes && roomTypes.data &&  roomTypes.data.map((type: any) => (
                <option key={type.id} value={type._id}>
                  {type.name}
                </option>
              ))}
            </select>
          </SoftBox>

          {/* Status Dropdown */}
          

          <SoftBox mb={2}>
          

            <SoftBox mb={1} ml={0.5}>
          

              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Status
              </SoftTypography>
            </SoftBox>
            <select
              name="status"
              value={formData.status}
              onChange={handleChange}
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "5px",
                border: "1px solid #ccc",
              }}
            >
              <option value="Available">Available</option>
              <option value="Occupied">Occupied</option>
              <option value="Maintenance">Maintenance</option>
            </select>
          </SoftBox>

          {/* Price Input */}
          
          
          <SoftBox mb={2}>
          

            <SoftBox mb={1} ml={0.5}>
          

              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Price
              </SoftTypography>
            </SoftBox>
            <SoftInput
        

              type="number"
              name="price"
              placeholder="Enter the price"
              value={formData.price}
              onChange={handleChange}
            />
          </SoftBox>

          {/* Max Occupancy Input */}
          

         

          {/* Additional Details Input */}
          

          <SoftBox mb={2}>
          

            <SoftBox mb={1} ml={0.5}>
          

              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Additional Details
              </SoftTypography>
            </SoftBox>
            <SoftInput
        

              type="text"
              name="additional_details"
              placeholder="Enter additional details"
              value={formData.additional_details}
              onChange={handleChange}
            />
          </SoftBox>

          {/* Submit Button */}
          

          <SoftBox mt={4} mb={1}>
         

            <SoftButton variant="gradient" color="final" fullWidth onClick={handleSubmit}>
              Submit
            </SoftButton>
          </SoftBox>
        </SoftBox>
      </SoftBox>
    </SoftBox>
  );
};

export default AddRoom;
